import React from 'react';
import Emergency from '../../../public/images/emergency.png';

export const FundEmergency = () => (
  <div className="emergency-fund justify-content-center">
    <img src={Emergency} alt="Emergency icon" />
    <p className="fs-12 lh-18 text-red mb-0">
      This fundraiser is in an urgent need of funds
    </p>
  </div>
);
 
export default FundEmergency;
